import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
  getDeleteParticipant,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAllLabs,
  updateAllLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import ApproveUnapproveModal from "components/Common/ApproveUnapproveModal";
import "assets/scss/table.scss";
import { countBy } from "lodash";
import EditparticipantsModal from "./editparticipantsModal";
import moment from "moment";

class ParticipantListN extends Component {
  constructor(props) {
    super(props);
    //this.displaySuccessMessage = this.displaySuccessMessage.bind(this);
    this.node = React.createRef();

    this.handleSchemeChange = this.handleSchemeChange.bind(this);
    this.handleSchemeModalOpen = this.handleSchemeModalOpen.bind(this);
    this.handleSchemeModalClose = this.handleSchemeModalClose.bind(this);
    this.state = {
      showModal: false,
      showImportModal: false,
      importFile: null,
      importError: null,
      editModal: false,
      selectedParticipant: null,
      AllLabs: [],
      approvedLabs: [],
      filteredLabs: [],
      ListCity: [],
      selectedProvince: "",
      provinceOptions: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],
      ListDepartment: [],
      ListCountry: [],
      ListType: [],
      ListSector: [],
      CycleList: [],
      selectedScheme: null,
      id: "",
      successMessage: "",
      btnText: "Copy",
      organization_name: "",
      isApproved: false,
      unapprovedModal: false,
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      pendingLabListColumns: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      pendingLabListColumns: [
        // {
        //   dataField: "id",
        //   text: "ID",
        //   sort: true,
        //   headerStyle: {
        //     textAlign: "center",
        //     backgroundColor: "#a6d4ff", // Light pink for header
        //   },
        //   style: (cell, row) => {
        //     const isPart =
        //       row.payment_settlement?.toString().toLowerCase() === "part";
        //     if (isPart) {
        //       return {
        //         // backgroundColor: "#c20505ff",
        //         color: "#c20505ff",
        //         textAlign: "center",
        //       };
        //     }
        //     return { backgroundColor: "#e0e0e0", textAlign: "center" };
        //   },
        //   filter: textFilter(),
        //   formatter: (cellContent, row) => <>{row.id}</>,
        // },
        {
          dataField: "registered_at",
          text: "Joining Date",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => (
            <>
              {row.registered_at
                ? moment(row.registered_at).format("DD-MMM-YY")
                : "-"}
            </>
          ),
        },
        {
          dataField: "district",
          text: "District",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.district}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "city",
          text: "City",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.city}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "name",
          text: "Participant",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Link
                  to="#"
                  onClick={(e) => this.openLabModal(e, row)}
                  style={{
                    cursor: "pointer",
                    color: isPart ? "#c20505ff" : "#007bff", // black if red row, else default blue
                  }}
                >
                  {row.name}
                </Link>
              </span>
            );
          },
        },
        {
          dataField: "lab_staff_name",
          text: "Name",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.lab_staff_name}
              </span>
            </>
          ),
          filter: textFilter(),
        },

        {
          dataField: "landline_registered_by",
          text: "Contact No.",
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllLabs.landline_registered_by}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "schemes",
          text: "Scheme",
          sort: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff",
            cursor: "pointer",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          formatter: (cellContent, lab) => {
            // Get IDs of all active cycles
            const activeCycleIds = new Set(
              (this.state.CycleList || [])
                .filter((c) => c.status?.toLowerCase() === "active")
                .map((c) => String(c.id)),
            );

            // Count only schemes that belong to an active cycle
            const count = Array.isArray(lab.schemes)
              ? lab.schemes.filter((s) =>
                  activeCycleIds.has(String(s.cycle_id)),
                ).length
              : 0;

            return (
              <Link
                to="#"
                onClick={() => this.handleSchemeModalOpen(lab)}
                style={{ fontWeight: "bold", textDecoration: "underline" }}
              >
                {count > 0 ? `${count}` : "-"}
              </Link>
            );
          },
          sortFunc: (a, b, order) => {
            // Sort also based on active cycle count only
            const activeCycleIds = new Set(
              (this.state.CycleList || [])
                .filter((c) => c.status?.toLowerCase() === "active")
                .map((c) => String(c.id)),
            );
            const countA = Array.isArray(a)
              ? a.filter((s) => activeCycleIds.has(String(s.cycle_id))).length
              : 0;
            const countB = Array.isArray(b)
              ? b.filter((s) => activeCycleIds.has(String(s.cycle_id))).length
              : 0;
            if (order === "asc") {
              return countA - countB;
            }
            return countB - countA;
          },
          filter: textFilter({
            onFilter: (filterValue, data) => {
              const count = parseInt(filterValue, 10);
              if (isNaN(count)) return data;
              const activeCycleIds = new Set(
                (this.state.CycleList || [])
                  .filter((c) => c.status?.toLowerCase() === "active")
                  .map((c) => String(c.id)),
              );
              return data.filter(
                (row) =>
                  Array.isArray(row.schemes) &&
                  row.schemes.filter((s) =>
                    activeCycleIds.has(String(s.cycle_id)),
                  ).length === count,
              );
            },
          }),
        },
        {
          dataField: "type",
          text: "Lab Type",
          skipDefaultStyles: true,
          headerStyle: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return { color: "#c20505ff", textAlign: "center" };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => (
            <span
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              {row.type || "–"}
            </span>
          ),
        },

        {
          dataField: "sector",
          text: "Sector",
          headerStyle: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return { color: "#c20505ff", textAlign: "center" };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => (
            <span
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              {row.sector || "–"}
            </span>
          ),
        },

        {
          dataField: "membership_status",
          text: "Membership",
          // skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllLabs) => {
            // Assuming the cycle status is stored in AllLabs.cycle_status or similar
            const cycleStatus = AllLabs.cycle_status || ""; // adjust if your key is different

            const displayStatus =
              cycleStatus.toLowerCase() === "active"
                ? "Active"
                : AllLabs.membership_status
                ? AllLabs.membership_status
                : "Inactive";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {displayStatus}
              </span>
            );
          },
          filter: textFilter(),
        },
        {
          dataField: "data",
          text: "id",
          isDummyField: true,
          editable: false,
          text: "Action",
          headerStyle: { textAlign: "center", backgroundColor: "#a6d4ff" },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#ff7f7f",
                // color: "black",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          formatter: (cellContent, AllLabs) => (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {/* {/ Update Button /} */}
                <Tooltip title="Update">
                  <Link
                    to={{
                      pathname: `/${this.state.organization_name}/editdata/${AllLabs.id}`,
                      state: { selectedParticipant: AllLabs },
                    }}
                  >
                    <i
                      className="mdi mdi-pencil font-size-18"
                      style={{ color: "#28a745" }}
                    ></i>
                  </Link>
                </Tooltip>
                {/* {/ Revert Status Button /} */}
                <Tooltip title="Membership Status">
                  <Link
                    className=""
                    to="#"
                    onClick={() => this.isMembershipModalOpen(AllLabs)} // Opens the Approved/Unapproved modal
                  >
                    <i className="mdi mdi-refresh font-size-14"></i>
                  </Link>
                </Tooltip>
                <Tooltip title="Delete">
                  <button
                    className="btn btn-link text-danger p-0"
                    onClick={() => this.handleDeleteParticipant(AllLabs)}
                    style={{
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </Tooltip>
                <Tooltip title="History">
                  <Link
                    className="fas fa-comment font-size-18"
                    to={`/${this.state.organization_name}/PaymentHistory/${AllLabs.id}`}
                    onClick={(e) => {
                      e.preventDefault();

                      if (!this.state.organization_name) {
                        return;
                      }

                      const url = `/${this.state.organization_name}/PaymentHistory/${AllLabs.id}`;
                      this.props.history.push(url);
                    }}
                  ></Link>
                </Tooltip>
              </div>
            </>
          ),
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.handleApprovedEvent = this.handleApprovedEvent.bind(this);
    this.togglePatientModal = this.togglePatientModal.bind(this);
    this.toggleMarketerModal = this.toggleMarketerModal.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleParticipantTypeChange =
      this.handleParticipantTypeChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  // displaySuccessMessage(message) {
  //  alert(message); // Replace this with your desired success message logic
  // }
  // Add this method to your class
  setShowModal = (value) => {
    this.setState({ showModal: value });
  };
  isPaymentModalOpen = (participant) => {
    this.setState({
      isPaymentModalOpen: true,
      selectedParticipant: participant, // Store full participant object
    });
  };
  handleDeleteParticipant = (participant) => {
    if (window.confirm("Are you sure you want to delete this participant?")) {
      new Promise((resolve, reject) => {
        this.props.ongetDeleteParticipant(participant.id, resolve, reject);
      })
        .then(() => {
          alert("Participant deleted successfully.");
        })
        .catch((errorMessage) => {
          alert(errorMessage); // Shows: "This participant has an active cycle and cannot be deleted."
        });
    }
  };

  isMembershipModalOpen = (participant) => {
    this.setState(
      {
        isMembershipModalOpen: true,
        selectedParticipant: participant, // Store the correct participant
      },
      () =>
        console.log(
          "Membership Modal Opened for:",
          this.state.selectedParticipant,
        ),
    );
  };

  handleSchemeCountChange = (e) => {
    const selectedSchemeCount = e.target.value;
    this.setState({ selectedSchemeCount }, () => {
      this.applyFilters();
    });
  };

  getMaxSchemeCount = () => {
    const { AllLabs } = this.state;

    if (!Array.isArray(AllLabs)) return 0;

    let max = 0;
    AllLabs.forEach((lab) => {
      const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
      if (count > max) max = count;
    });

    return max;
  };

  handleParticipantTypeChange(event) {
    const selectedParticipantType = event.target.value;
    this.setState({ selectedParticipantType }, () => {
      this.applyFilters();
    });
  }

  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
    const { organization_name } = this.state; // Extract from state
  };

  applyFilters = () => {
    const {
      AllLabs,
      selectedParticipantType,
      selectedScheme,
      selectedProvince,
      selectedCycle,
      organization_name,
    } = this.state;

    const filteredData = AllLabs.filter((lab) => {
      const membershipStatus = lab.membership_status?.trim().toLowerCase();
      const membershipDetail = lab.membership_status_detail
        ? lab.membership_status_detail.trim().toLowerCase()
        : "";
      let matchesParticipantType = false;

      if (selectedParticipantType === "All Participant") {
        matchesParticipantType = true; // Show all participants
      } else if (selectedParticipantType === "Approved Participant") {
        matchesParticipantType =
          membershipStatus === "active" || membershipDetail === "active"; // Approved or Active participants
      } else if (selectedParticipantType === "Pending Participant") {
        matchesParticipantType = membershipStatus === "pending"; // Pending participants
      } else if (selectedParticipantType === "Unapproved Participant") {
        matchesParticipantType = membershipStatus === "inactive"; // Only participants with "inactive" membership status
      } else if (selectedParticipantType === "Suspended Participant") {
        matchesParticipantType = membershipStatus === "suspended"; // Suspended participants
      } else if (selectedParticipantType === "New Register") {
        matchesParticipantType = membershipStatus === "new register";
      }
      const matchesProvince =
        !this.state.selectedProvince ||
        (lab.province &&
          lab.province.toLowerCase() ===
            this.state.selectedProvince.toLowerCase());
      // 🧠 Match selected scheme
      const matchesScheme =
        !selectedScheme ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) =>
              String(s.scheme_id) === String(selectedScheme) ||
              String(s.scheme_name) === String(selectedScheme),
          ));

      // 🧩 Match selected cycle (only when selected)
      const matchesCycle =
        !selectedCycle ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) => s.cycle_id?.toString() === selectedCycle.toString(),
          ));

      // ✅ Return labs that match all filters
      // NEW FILTER — scheme count
      const matchesSchemeCount =
        !this.state.selectedSchemeCount ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.length === parseInt(this.state.selectedSchemeCount));

      return (
        matchesParticipantType &&
        matchesScheme &&
        matchesCycle &&
        matchesSchemeCount &&
        matchesProvince
      );
    });

    // Special handling for "Pending Participant"
    if (selectedParticipantType === "Pending Participant") {
      this.props.history.push(`/${organization_name}/pending-participant`);
      return;
    }

    // Update the filtered list in the state for other participant types
    this.setState({ filteredLabs: filteredData }, () => {});
  };

  applyFiltersFromQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const filterType = queryParams.get("filterType");
    const filterValue = queryParams.get("filterValue");

    if (filterType && filterValue) {
      // Update the state based on query parameters
      this.setState(
        {
          selectedParticipantType: filterValue, // Set selected type in state
        },
        () => {
          this.applyFilters(); // Apply filters after updating the state
        },
      );
    }
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  toggleMembershipModal = () => {
    this.setState(
      (prevState) => ({
        isMembershipModalOpen: !prevState.isMembershipModalOpen,
      }),
      () => {},
    );
  };
  togglePaymentModal = () => {
    this.setState(
      (prevState) => ({
        isPaymentModalOpen: !prevState.isPaymentModalOpen,
      }),
      () => {},
    );
  };
  handleSchemeModalOpen(lab) {
    const cycleList = this.state.CycleList || [];

    const schemesWithRounds = (lab.schemes || []).map((scheme) => {
      const matchedCycle = cycleList.find(
        (cycle) => String(cycle.id) === String(scheme.cycle_id),
      );

      const rawStatus = matchedCycle ? matchedCycle.status : null;
      const formattedStatus = rawStatus
        ? rawStatus.charAt(0).toUpperCase() + rawStatus.slice(1).toLowerCase()
        : "–";

      return {
        ...scheme,
        round_numbers: matchedCycle ? matchedCycle.round_numbers : "–",
        reportstatus: matchedCycle ? matchedCycle.reportstatus : null,
        cycle_status: formattedStatus, // ✅ fixed typo + proper capitalization
      };
    });

    this.setState({
      showSchemeModal: true,
      selectedSchemes: schemesWithRounds,
      selectedParticipant: lab,
    });
  }

  handleSchemeModalClose() {
    this.setState({
      showSchemeModal: false,
      selectedSchemes: [],
      selectedParticipant: null,
    });
  }
  handleEditSubmit(values) {
    console.log("handleEditSubmit values:", values);
    console.log("lab_staff_designation:", values.lab_staff_designation);

    // ✅ Helper: returns undefined for empty/null/"undefined" values
    const sanitize = (value) =>
      value === undefined ||
      value === null ||
      String(value).trim() === "" ||
      String(value).trim().toLowerCase() === "undefined"
        ? undefined
        : String(value).trim();

    const updatedData = {
      id: values.id,
      name: sanitize(values.name),
      email: sanitize(values.email),
      province: sanitize(values.province),
      lab_staff_designation: sanitize(values.lab_staff_designation),
      password_foradmins: sanitize(values.password_foradmins),
      department: sanitize(values.department),
      country: sanitize(values.country),
      type: sanitize(values.type),
      sector: sanitize(values.sector),
      address: sanitize(values.address),
      shipping_address: sanitize(values.shipping_address),
      billing_address: sanitize(values.billing_address),
      website: sanitize(values.website),
      marketer_name: sanitize(values.marketer_name),
      city: sanitize(values.city),
      district: sanitize(values.district),
      lab_staff_name: sanitize(values.lab_staff_name),
      email_participant: sanitize(values.email_participant),
      landline_registered_by: sanitize(values.landline_registered_by),
      payment_status: sanitize(values.payment_status),
      payment_reconcile_status: sanitize(values.payment_reconcile_status),
    };

    console.log(
      "sanitized lab_staff_designation:",
      updatedData.lab_staff_designation,
    );

    // ✅ Remove keys where sanitize() returned undefined so they're never sent
    Object.keys(updatedData).forEach((key) => {
      if (updatedData[key] === undefined) delete updatedData[key];
    });

    console.log("final updatedData being sent:", updatedData);

    // Send update
    this.props.onupdateAllLabs(updatedData);

    this.setState({ successMessage: "Participant updated successfully" });

    setTimeout(() => {
      this.props.ongetApprovedLabs(this.state.user_id);
    }, 1000);

    setTimeout(() => {
      this.setState({ editModal: false, successMessage: "" });
    }, 2000);
  }

  componentDidMount() {
    // Retrieve user_id from localStorage
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      return;
    }

    // Set user_id in state
    this.setState({ user_id }, () => {
      // Get organization_name from URL params
      const { organization_name } = this.props.match.params || {};

      if (organization_name) {
        this.setState({ organization_name }, () => {
          // // Initialize dropdown value
          // this.setInitialDropdownValue();
          this.fetchData(this.state.user_id);
          this.applyFiltersFromQueryParams();
          // Fetch data from APIs
          this.fetchData(user_id);
        });
      } else {
      }
    });
  }
  handleSchemeSelect = (e) => {
    const selectedScheme = e.target.value;

    // If user selects empty (Select Scheme)
    if (!selectedScheme) {
      this.setState({
        selectedScheme: null,
        showCycleFilter: false,
        selectedCycle: null,
        filteredCycleOptions: [],
        filteredLabs: this.state.AllLabs, // <-- RESET TABLE DATA HERE
      });
      return;
    }

    // If a scheme is selected → continue normal logic
    const filteredCycleOptions = this.state.CycleList.filter(
      (cycle) => String(cycle.scheme_id) === String(selectedScheme),
    );

    this.setState(
      {
        selectedScheme,
        filteredCycleOptions,
        showCycleFilter: true,
        selectedCycle: null,
      },
      () => {
        this.applyFilters(); // <-- Apply your existing filters
      },
    );
  };

  handleCycleSelect = (e) => {
    const selectedCycle = e.target.value;
    this.setState({ selectedCycle }, () => {
      this.applyFilters();
    });
  };
  // Fetch all required data
  fetchData(user_id) {
    const {
      onGetParticipantPayment,
      ongetApprovedLabs,
      ongetcyclelist,
      onGetPendingLabs,
    } = this.props;

    // Call participant payment API
    onGetParticipantPayment(user_id);

    // Call approved labs API
    ongetApprovedLabs(user_id);

    // Call cycle list API
    ongetcyclelist(user_id);

    // Call pending labs API
    onGetPendingLabs(user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.ListCity !== this.props.ListCity) {
      this.setState({ ListCity: this.props.ListCity });
    }
    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict });
    }
    if (prevProps.ListProvince !== this.props.ListProvince) {
      this.setState({ ListProvince: this.props.ListProvince });
    }
    if (prevProps.ListDesignation !== this.props.ListDesignation) {
      this.setState({ ListDesignation: this.props.ListDesignation });
    }
    if (prevProps.ListDepartment !== this.props.ListDepartment) {
      this.setState({ ListDepartment: this.props.ListDepartment });
    }
    if (prevProps.ListCountry !== this.props.ListCountry) {
      this.setState({ ListCountry: this.props.ListCountry });
    }
    if (prevProps.ListType !== this.props.ListType) {
      this.setState({ ListType: this.props.ListType });
    }
    if (prevProps.ListSector !== this.props.ListSector) {
      this.setState({ ListSector: this.props.ListSector });
    }
    if (prevState.filteredLabs !== this.state.filteredLabs) {
    }
    if (prevProps.approvedLabs !== this.props.approvedLabs) {
    }
    if (prevProps.CycleList !== this.props.CycleList) {
      this.setState({ CycleList: this.props.CycleList });
    }
    if (prevProps.PaymentSchemeList !== this.props.PaymentSchemeList) {
      this.setState({ PaymentSchemeList: this.props.PaymentSchemeList });
    }
    if (prevProps.AllLabs !== this.props.AllLabs) {
      // Extract unique provinces from API
      const provinces = [
        ...new Set(
          (this.props.AllLabs || []).map((lab) => lab.province).filter(Boolean),
        ),
      ];

      this.setState(
        {
          AllLabs: this.props.AllLabs,
          provinceOptions: provinces,
        },
        () => {
          this.applyFilters();
        },
      );
    }

    // Ensure filteredCycleList is updated without modifying CycleList
    if (
      prevProps.AllLabs !== this.props.AllLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      // Extract unique scheme names from AllLabs
      const participantSchemes = new Set(
        this.props.AllLabs.flatMap(
          (lab) => lab.schemes?.map((scheme) => scheme.scheme_name) || [],
        ),
      );

      // Generate the filtered list for participant dropdown
      const filteredCycleList = this.props.CycleList.filter((cycle) =>
        participantSchemes.has(cycle.scheme_name),
      );

      // Update state with both lists
      this.setState({
        CycleList: this.props.CycleList, // Original list for payment modal
        filteredCycleList, // Filtered list for participant filters
      });
    }
  }

  openPatientModal = (e, arg) => {
    this.setState({
      PatientModal: true,
      email: arg.email,
      landline_registered_by: arg.landline_registered_by,
    });
  };

  // toggleEditModal = (participant = null) => {

  //   this.setState((prev) => ({
  //     editModal: !prev.editModal,
  //     selectedParticipant: participant,
  //   }));
  // };
  toggleEditModal = (participant = null) => {
    this.setState((prev) => ({
      editModal: !prev.editModal,
      selectedParticipant: participant || prev.selectedParticipant, // Keep existing if no new participant
      showModal: participant ? true : !prev.showModal, // Set showModal based on whether we have participant data
    }));
  };

  toggleLabModal = () => {
    this.setState((prevState) => ({
      LabModal: !prevState.LabModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };
  openLabModal = (e, arg) => {
    this.setState({
      LabModal: true,
      email: arg.email,
      name: arg.name,
      lab_code: arg.lab_code,
      password_foradmins: arg.password_foradmins,
      shipping_address: arg.shipping_address,
      billing_address: arg.billing_address,
    });
  };
  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  togglePatientModal = () => {
    this.setState((prevState) => ({
      PatientModal: !prevState.PatientModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  openMarketerModal = (e, arg) => {
    this.setState({
      MarketerModal: true,
      marketer_name: arg.marketer_name,
      marketer_phone: arg.marketer_phone,
    });
  };
  toggleMarketerModal = () => {
    this.setState((prevState) => ({
      MarketerModal: !prevState.MarketerModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  handleApprovedEvent = (id) => {
    this.setState({ id: id, isApproved: true, unapprovedModal: true });
  };

  handleUnapprovedEvent = (id) => {
    this.setState({ id: id, isApproved: false, unapprovedModal: true });
  };

  callOnApproveUnapproveLab = () => {
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;

    const data = {
      id: this.state.user_id,
      labId: this.state.id,
      isApproved: this.state.isApproved,
    };

    // calling to unapprove lab
    onApproveUnapproveLab(data);

    // Calling to update list record
    setTimeout(() => {
      onGetPendingLabs(this.state.user_id);
    }, 1000);

    this.setState({ unapprovedModal: false });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  exportToExcel = () => {
    const { filteredLabs, selectedScheme } = this.state;

    if (!filteredLabs || filteredLabs.length === 0) {
      alert("No data available to export.");
      return;
    }

    const selectedFields = [
      // { key: "id", label: "ID" },
      // { key: "registered_at", label: "Joining Date" },
      { key: "province", label: "Province" },
      { key: "district", label: "District" },
      { key: "city", label: "City" },
      { key: "name", label: "Name" },
      { key: "address", label: "Address" },
      { key: "shipping_address", label: "Address Shipping" },
      { key: "billing_address", label: "Address Billing Address" },
      // { key: "lab_code", label: "lab_code" },
      { key: "email", label: "Email" },
      { key: "email_participant", label: "Email of Notification Person" },
      // { key: "password_foradmins", label: "password" },
      { key: "lab_staff_name", label: "Name of Notification Person" },
      { key: "lab_staff_designation", label: "Designation" },
      {
        key: "landline_registered_by",
        label: "Contact No of Notification Person",
      },
      // { key: "schemes", label: "Schemes" },
      { key: "type", label: "Lab Type" },
      { key: "sector", label: "Sector" },
      // { key: "membership_status", label: "Membership Status" },
      // { key: "payment_status", label: "Payment Status" },
      // { key: "payment_reconcile_status", label: "Payment Reconcile Status" },
      // { key: "payment_settlement", label: "Payment Settlement" },
      // { key: "remaining_amount", label: "Remaining Amount" },
      { key: "department", label: "Department" },
      // { key: "country", label: "Country" },
      // { key: "website", label: "Website" },
    ];

    const dataToExport = filteredLabs.map((item) => {
      const row = {};
      selectedFields.forEach(({ key, label }) => {
        if (key === "schemes") {
          if (Array.isArray(item.schemes)) {
            const uniqueSchemeNames = [
              ...new Set(item.schemes.map((s) => s.scheme_name)),
            ];
            row[label] = uniqueSchemeNames.join(", ");
          } else {
            row[label] = "N/A";
          }
        } else if (key === "registered_at") {
          row[label] = item.registered_at
            ? moment(item.registered_at).format("DD-MMM-YY")
            : "N/A";
        } else {
          row[label] =
            item[key] !== undefined && item[key] !== null && item[key] !== ""
              ? item[key]
              : "N/A";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const colWidths = Object.keys(dataToExport[0]).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...dataToExport.map((row) =>
          row[key] ? row[key].toString().length : 10,
        ),
      );
      return { wch: maxLength + 2 };
    });

    ws["!cols"] = colWidths;
    const wb = { Sheets: { Participants: ws }, SheetNames: ["Participants"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    // 🆕 Extract scheme_id and cycle_id from selectedScheme if available
    const [schemeId, cycleId] = (selectedScheme || "").split("-");
    const fileName = schemeId
      ? `Participants_Scheme_${schemeId}_Cycle_${cycleId}.xlsx`
      : "All_Participants.xlsx";

    saveAs(data, fileName);
  };
  refreshPage = () => {
    // call your API or reload data
    this.fetchData(this.state.user_id);
  };

  toggleImportModal = () => {
    this.setState((prevState) => ({
      showImportModal: !prevState.showImportModal,
      importFile: null,
      importError: null,
    }));
  };

  handleImport = async () => {
    const { importFile } = this.state;

    if (!importFile) {
      this.setState({ importError: "Please select a file." });
      return;
    }

    const SAFE_FIELDS = [
      "name",
      "type",
      "sector",
      "city",
      "district",
      "province",
      "lab_staff_name",
      "lab_staff_designation",
      "landline_registered_by",
      "address",
      "shipping_address",
      "billing_address",
    ];

    const COL_MAP = {
      Name: "name",
      "Lab Type": "type",
      Sector: "sector",
      City: "city",
      District: "district",
      Province: "province",
      "Name of Notification Person": "lab_staff_name",
      Designation: "lab_staff_designation",
      "Contact No of Notification Person": "landline_registered_by",
      Address: "address",
      "Address Shipping": "shipping_address",
      "Billing Address": "billing_address",
      Email: "email",
      "Address Billing Address": "billing_address",
      // ID: "id", // <-- used ONLY for matching, not in SAFE_FIELDS
    };

    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        let updated = 0;
        let skipped = 0;
        let notFound = 0;
        const errors = [];

        for (let i = 0; i < rows.length; i++) {
          const row = rows[i];

          const mapped = {};
          Object.entries(COL_MAP).forEach(([excelCol, apiField]) => {
            if (row[excelCol] !== undefined) {
              mapped[apiField] = String(row[excelCol] || "").trim();
            }
          });

          if (!mapped.email) {
            skipped++;
            errors.push(`Row ${i + 2}: Missing Email — skipped`);
            continue;
          }

          // Match by email — database-enforced unique, guaranteed no duplicates
          const existing = this.state.AllLabs.find(
            (p) =>
              p.email &&
              mapped.email &&
              p.email.trim().toLowerCase() ===
                mapped.email.trim().toLowerCase(),
          );

          if (!existing) {
            notFound++;
            errors.push(
              `Row ${i + 2}: Email "${mapped.email}" not found — skipped`,
            );
            continue;
          }
          const payload = { id: existing.id };
          SAFE_FIELDS.forEach((field) => {
            if (mapped[field] !== undefined && mapped[field] !== "") {
              payload[field] = mapped[field]; // Only SAFE_FIELDS go in
            }
          });

          // Build change log — what changed from → to
          const changes = [];
          SAFE_FIELDS.forEach((field) => {
            if (mapped[field] !== undefined && mapped[field] !== "") {
              const oldVal = String(existing[field] || "").trim();
              const newVal = String(mapped[field] || "").trim();
              if (oldVal !== newVal) {
                changes.push(`${field}: "${oldVal}" → "${newVal}"`);
              }
              payload[field] = mapped[field];
            }
          });

          // Attach change log comment to payload
          // Your backend should save this as an activity log
          if (changes.length > 0) {
            payload.import_log = true;
            payload.comments = changes.join("\n");
            payload.added_by = this.state.user_id;
          }

          try {
            this.props.onupdateAllLabs(payload);
            updated++;
          } catch (err) {
            errors.push(`Row ${i + 1} (${mapped.name}): ${err.message}`);
          }
        }

        setTimeout(() => {
          this.props.ongetApprovedLabs(this.state.user_id);
        }, 1000);

        this.toggleImportModal();
        alert(
          `Import complete!\n✅ Updated: ${updated}\n⏭ Skipped: ${skipped}` +
            (errors.length ? `\n❌ Errors:\n${errors.join("\n")}` : ""),
        );
      };

      reader.readAsArrayBuffer(importFile);
    } catch (error) {
      this.setState({ importError: "Error reading file. Please try again." });
    }
  };

  render() {
    const { SearchBar } = Search;
    const { ListCity } = this.state;
    const { ListDistrict } = this.state;
    const { ListProvince } = this.state;
    const { ListDesignation } = this.state;
    const { ListDepartment } = this.state;
    const { ListCountry } = this.state;
    const { ListType, ListSector } = this.state;

    const { AllLabs } = this.props;
    const data = this.state.data;
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;
    const { isPaymentModalOpen, togglePaymentModal } = this.props;
    const { isMembershipModalOpen, toggleMembershipModal } = this.props;
    const { filteredLabs, selectedParticipantType, selectedScheme } =
      this.state;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllLabs.length, // replace later with size(AllLabs),
      custom: true,
    };
    const maxSchemeCount = this.getMaxSchemeCount();
    const schemeCountOptions = Array.from(
      { length: maxSchemeCount },
      (_, i) => i + 1,
    );
    // const { isPaymentModalOpen } = this.state;
    const { approvedLabs, CycleList } = this.state;

    const participantOptions = (this.props.approvedLabs || []).map(
      (participant) => ({
        value: participant.id, // ensure this is the correct unique identifier
        label: participant.name, // or any other field you'd like to display
      }),
    );
    const schemeOptions = CycleList.map((scheme) => ({
      value: scheme.id, // Use scheme ID instead of scheme name
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
    }));

    const { isModalOpen, toggleModal, isOpen, toggle, onSubmit } = this.state;
    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];
    const customStyles = {
      // <-- This is invalid here
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Pending Labs | External QC</title>
          </MetaTags>

          <ApproveUnapproveModal
            show={this.state.unapprovedModal}
            onYesClick={this.callOnApproveUnapproveLab}
            onCloseClick={() => this.setState({ unapprovedModal: false })}
          />

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Lists of Participants" />
            <Row className="mb-2">
              <Col sm="12">
                <p
                  style={{
                    fontSize: "14px",
                    color: "#000000",
                    marginLeft: "10px",
                    marginBottom: "4px",
                  }}
                >
                  <strong>Note:</strong> Scheme count in the table reflects only{" "}
                  <strong>Active Cycle</strong> schemes. Click the count to view
                  full details including all cycles.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <Row className="justify-content-end">
                      <Col lg="auto" className="text-end">
                        {/* NEW — Import button */}
                        {/* <Button
                          color="success"
                          onClick={() =>
                            this.setState({ showImportModal: true })
                          }
                          className="mb-3 me-2"
                        >
                          Import from Excel
                        </Button> */}

                        {/* ORIGINAL — Export button, completely unchanged */}
                        <Button
                          onClick={this.exportToExcel}
                          className="mb-3"
                          disabled={
                            !this.state.AllLabs ||
                            this.state.AllLabs.length === 0
                          }
                        >
                          Export to Excel
                        </Button>
                      </Col>
                    </Row>

                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.pendingLabListColumns}
                      data={this.state.filteredLabs}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.pendingLabListColumns}
                          data={this.state.filteredLabs}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="12">
                                  <div className="ms-2 mb-4">
                                    <div className="container">
                                      {/* Row 1: Main Filters */}
                                      <div className="row align-items-center mb-3">
                                        {/* Col 1: Participant Type Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            onChange={
                                              this.handleParticipantTypeChange
                                            }
                                            value={
                                              this.state.selectedParticipantType
                                            }
                                          >
                                            <option value="All Participant">
                                              All Participant
                                            </option>
                                            <option value="Approved Participant">
                                              Approved Participant
                                            </option>
                                            <option value="Unapproved Participant">
                                              Unapproved Participant
                                            </option>
                                            <option value="Pending Participant">
                                              Pending Participant
                                            </option>
                                            <option value="Suspended Participant">
                                              Suspended Participant
                                            </option>
                                          </select>
                                        </div>

                                        {/* Col 2: Province Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            value={this.state.selectedProvince}
                                            onChange={(e) => {
                                              this.setState(
                                                {
                                                  selectedProvince:
                                                    e.target.value,
                                                },
                                                () => {
                                                  this.applyFilters();
                                                },
                                              );
                                            }}
                                          >
                                            <option value="">
                                              Select Province
                                            </option>
                                            {this.state.provinceOptions.map(
                                              (prov, i) => (
                                                <option key={i} value={prov}>
                                                  {prov}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </div>

                                        {/* Col 3: Scheme Filter */}
                                        <div className="col-3">
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.selectedScheme || ""
                                            }
                                            onChange={(e) =>
                                              this.handleSchemeSelect(e)
                                            }
                                          >
                                            <option value="">
                                              Select Scheme
                                            </option>
                                            {Array.isArray(
                                              this.state.filteredCycleList,
                                            ) &&
                                              [
                                                ...new Map(
                                                  this.state.filteredCycleList.map(
                                                    (item) => [
                                                      String(item.scheme_id),
                                                      item,
                                                    ],
                                                  ),
                                                ).values(),
                                              ].map((scheme) => (
                                                <option
                                                  key={scheme.scheme_id}
                                                  value={String(
                                                    scheme.scheme_id,
                                                  )}
                                                >
                                                  {scheme.scheme_name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>

                                        {/* Col 4: Cycle Filter (if scheme selected) OR Scheme Count */}
                                        <div className="col-3">
                                          {this.state.showCycleFilter ? (
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedCycle || ""
                                              }
                                              onChange={(e) =>
                                                this.handleCycleSelect(e)
                                              }
                                            >
                                              <option value="">
                                                Select Cycle
                                              </option>
                                              {this.state.filteredCycleOptions.map(
                                                (cycle) => (
                                                  <option
                                                    key={cycle.id}
                                                    value={cycle.id}
                                                  >
                                                    Cycle {cycle.cycle_no}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          ) : (
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedSchemeCount
                                              }
                                              onChange={
                                                this.handleSchemeCountChange
                                              }
                                            >
                                              <option value="">
                                                Scheme Count
                                              </option>
                                              {schemeCountOptions.map(
                                                (count) => (
                                                  <option
                                                    key={count}
                                                    value={count}
                                                  >
                                                    {count}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          )}
                                        </div>
                                      </div>

                                      {/* Row 2: Scheme Count (only when Cycle Filter is visible) */}
                                      {this.state.showCycleFilter && (
                                        <div className="row align-items-center">
                                          <div className="col-3">
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedSchemeCount
                                              }
                                              onChange={
                                                this.handleSchemeCountChange
                                              }
                                            >
                                              <option value="">
                                                Scheme Count
                                              </option>
                                              {schemeCountOptions.map(
                                                (count) => (
                                                  <option
                                                    key={count}
                                                    value={count}
                                                  >
                                                    {count}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={`table-${
                                        Array.isArray(this.state.filteredLabs)
                                          ? this.state.filteredLabs.length
                                          : 0
                                      }`}
                                      keyField="id"
                                      data={this.state.filteredLabs}
                                      columns={this.state.pendingLabListColumns}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes="table align-middle table-condensed table-hover table-body-white"
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses="table-header-grey"
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                      rowStyle={(row, rowIndex) => {
                                        const isPart =
                                          row.payment_settlement
                                            ?.toString()
                                            .toLowerCase() === "part";
                                        return isPart
                                          ? {
                                              backgroundColor: "#ff7f7f",
                                              color: "black",
                                            } // Entire row #ff7f7f
                                          : {};
                                      }}
                                    />
                                    <Modal
                                      isOpen={this.state.isMembershipModalOpen}
                                      toggle={this.toggleMembershipModal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMembershipModal}
                                      >
                                        Updating Membership for{" "}
                                        {this.state.selectedParticipant?.name ||
                                          "Unknown"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={{
                                            membership: "", // Default empty value
                                            participant:
                                              this.state.selectedParticipant
                                                ?.id || "",
                                            // Participant ID passed as prop
                                            added_by: localStorage.getItem(
                                              "authUser",
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser",
                                                  ),
                                                ).user_id
                                              : "",
                                          }}
                                          validationSchema={Yup.object().shape({
                                            membership:
                                              Yup.string().required(
                                                "Status required",
                                              ),
                                          })}
                                          onSubmit={async (
                                            values,
                                            { setSubmitting, resetForm },
                                          ) => {
                                            if (!values.participant) {
                                              return;
                                            }

                                            const userId = localStorage.getItem(
                                              "authUser",
                                            )
                                              ? JSON.parse(
                                                  localStorage.getItem(
                                                    "authUser",
                                                  ),
                                                ).user_id
                                              : "";

                                            const UpdateMembership = {
                                              membership_status:
                                                values.membership, // Correct key
                                              added_by: userId, // This should match the logged-in user's ID
                                              participant: values.participant, // Participant ID should come here
                                            };

                                            try {
                                              await this.props.onupdateMembershipStatus(
                                                this.state.user_id,
                                                UpdateMembership,
                                              );
                                              this.props.ongetApprovedLabs(
                                                this.state.user_id,
                                              );
                                              this.props.onupdateMembershipStatus(
                                                this.state.user_id,
                                              );
                                              await this.props.onGetPendingLabs(
                                                this.state.user_id,
                                              ); //membership modal
                                              this.setState({
                                                isMembershipModalOpen: false,
                                              }); // Close modal here
                                              resetForm();
                                              this.displaySuccessMessage(
                                                "Membership status updated successfully!",
                                              );
                                            } catch (error) {}
                                            this.setState({
                                              isMembershipModalOpen: false,
                                            });
                                            setSubmitting(false);
                                          }}
                                        >
                                          {({
                                            values,
                                            errors,
                                            touched,
                                            setFieldValue,
                                          }) => {
                                            const membershipOptions = [
                                              {
                                                value: "Active",
                                                label: "Active",
                                              },
                                              {
                                                value: "Inactive",
                                                label: "Inactive",
                                              },
                                              {
                                                value: "Suspended",
                                                label: "Suspended",
                                              },
                                            ];

                                            return (
                                              <Form>
                                                <Row>
                                                  <Col>
                                                    <Label>
                                                      Membership Status
                                                    </Label>
                                                    <Select
                                                      name="membership"
                                                      options={
                                                        membershipOptions
                                                      }
                                                      placeholder="Select Status"
                                                      className={
                                                        errors.participant &&
                                                        touched.participant
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        setFieldValue(
                                                          "membership",
                                                          selectedOption?.value ||
                                                            "",
                                                        );
                                                      }}
                                                      value={
                                                        membershipOptions.find(
                                                          (option) =>
                                                            option.value ===
                                                            values.membership,
                                                        ) || null
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="membership"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>
                                                </Row>

                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    type="submit"
                                                  >
                                                    Save
                                                  </Button>
                                                </ModalFooter>
                                              </Form>
                                            );
                                          }}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>

                                    <Modal
                                      isOpen={this.state.LabModal}
                                      className={this.props.className}
                                      // onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleLabModal}
                                        tag="h4"
                                      >
                                        <strong>
                                          {this.state.name || "Lab Details"}
                                        </strong>
                                      </ModalHeader>

                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Lab Code
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.lab_code
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      UserName
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Password
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .password_foradmins
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Shipping Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .shipping_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Billing Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .billing_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.showSchemeModal}
                                      toggle={this.handleSchemeModalClose}
                                      size="lg"
                                    >
                                      <ModalHeader
                                        toggle={this.handleSchemeModalClose}
                                      >
                                        {this.state.selectedParticipant?.name ||
                                          "Participant"}{" "}
                                        — Purchased Schemes
                                      </ModalHeader>
                                      <ModalBody>
                                        {this.state.selectedSchemes &&
                                        this.state.selectedSchemes.length >
                                          0 ? (
                                          <div className="table-responsive">
                                            <table className="table table-bordered table-hover align-middle mb-0">
                                              <thead
                                                style={{
                                                  backgroundColor: "#a6d4ff",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <tr>
                                                  <th>Scheme Name</th>
                                                  <th>Cycle No</th>
                                                  <th>Cycle Status</th>
                                                  <th>Issued Rounds</th>
                                                  <th>Payment Settlement</th>
                                                  <th>Payment Status</th>
                                                  <th>COP</th>
                                                  <th>COA</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.selectedSchemes.map(
                                                  (scheme, i) => {
                                                    const isPart =
                                                      this.state.selectedParticipant?.payment_settlement
                                                        ?.toString()
                                                        .toLowerCase() ===
                                                      "part";

                                                    const isActiveCycle =
                                                      scheme.cycle_status?.toLowerCase() ===
                                                      "active";

                                                    return (
                                                      <tr
                                                        key={i}
                                                        style={{
                                                          backgroundColor:
                                                            isPart
                                                              ? "#ff7f7f"
                                                              : "#e0e0e0",
                                                          color: isPart
                                                            ? "#c20505ff"
                                                            : "black",
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        <td>
                                                          {scheme.scheme_name ||
                                                            "–"}
                                                        </td>
                                                        <td>
                                                          {scheme.cycle_no ||
                                                            "–"}
                                                        </td>

                                                        {/* Cycle Status */}
                                                        <td>
                                                          <span
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              color:
                                                                isActiveCycle
                                                                  ? "green"
                                                                  : "red",
                                                            }}
                                                          >
                                                            {scheme.cycle_status ||
                                                              "–"}
                                                          </span>
                                                        </td>

                                                        <td>
                                                          {scheme.round_numbers ||
                                                            "–"}
                                                        </td>

                                                        {/* Payment Settlement */}
                                                        <td>
                                                          <span
                                                            style={{
                                                              color: isPart
                                                                ? "#c20505ff"
                                                                : "black",
                                                            }}
                                                          >
                                                            {this.state
                                                              .selectedParticipant
                                                              ?.payment_settlement ||
                                                              "–"}
                                                            {isPart &&
                                                              this.state
                                                                .selectedParticipant
                                                                ?.remaining_amount && (
                                                                <div
                                                                  style={{
                                                                    fontSize:
                                                                      "0.85em",
                                                                    color:
                                                                      "#c20505ff",
                                                                  }}
                                                                >
                                                                  Remaining:{" "}
                                                                  {Number(
                                                                    this.state
                                                                      .selectedParticipant
                                                                      .remaining_amount,
                                                                  ).toLocaleString() ||
                                                                    "–"}
                                                                </div>
                                                              )}
                                                          </span>
                                                        </td>

                                                        {/* Payment Status */}
                                                        <td>
                                                          {(() => {
                                                            const reconcileStatus =
                                                              this.state.selectedParticipant?.payment_reconcile_status?.toLowerCase();
                                                            const isVerified =
                                                              reconcileStatus ===
                                                              "verified";
                                                            return (
                                                              <span
                                                                style={{
                                                                  color:
                                                                    isVerified
                                                                      ? "green"
                                                                      : "red",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                {this.state
                                                                  .selectedParticipant
                                                                  ?.payment_status ||
                                                                  "–"}
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>

                                                        {/* COP */}
                                                        <td>
                                                          {(() => {
                                                            const isVerified =
                                                              this.state.selectedParticipant?.payment_reconcile_status?.toLowerCase() ===
                                                              "verified";
                                                            const organization_name =
                                                              this.state
                                                                .organization_name;
                                                            const participantId =
                                                              this.state
                                                                .selectedParticipant
                                                                ?.id;

                                                            if (isVerified) {
                                                              return (
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() => {
                                                                    this.props.history.push(
                                                                      `/${organization_name}/${participantId}/certificate?scheme_id=${scheme.scheme_id}&cycle_id=${scheme.cycle_id}`,
                                                                    );
                                                                  }}
                                                                >
                                                                  View
                                                                </span>
                                                              );
                                                            }
                                                            return (
                                                              <span className="text-muted">
                                                                -
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>

                                                        {/* COA */}
                                                        <td>
                                                          {(() => {
                                                            const isEligible =
                                                              scheme.coa_status ===
                                                              "Eligible";
                                                            const organization_name =
                                                              this.state
                                                                .organization_name;
                                                            const participantId =
                                                              this.state
                                                                .selectedParticipant
                                                                ?.id;

                                                            if (isEligible) {
                                                              return (
                                                                <span
                                                                  className="text-success"
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() => {
                                                                    this.props.history.push(
                                                                      `/${organization_name}/${participantId}/certificate_of_achievement?scheme_id=${scheme.scheme_id}&cycle_id=${scheme.cycle_id}`,
                                                                    );
                                                                  }}
                                                                >
                                                                  View
                                                                </span>
                                                              );
                                                            }
                                                            return (
                                                              <span className="text-muted">
                                                                -
                                                              </span>
                                                            );
                                                          })()}
                                                        </td>
                                                      </tr>
                                                    );
                                                  },
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ) : (
                                          <p className="text-center">
                                            No schemes found.
                                          </p>
                                        )}
                                      </ModalBody>
                                    </Modal>
                                    {this.state.showModal &&
                                      this.state.editModal &&
                                      this.state.selectedParticipant && (
                                        <EditparticipantsModal
                                          isOpen={this.state.editModal}
                                          toggle={() => {
                                            this.setState({
                                              editModal: false,
                                              showModal: false,
                                              selectedParticipant: null,
                                            });
                                            this.fetchData(this.state.user_id);
                                          }}
                                          participant={
                                            this.state.selectedParticipant
                                          }
                                          onSuccess={() => {
                                            this.refreshPage();
                                          }}
                                        />
                                      )}
                                    <Modal
                                      isOpen={this.state.showImportModal}
                                      toggle={this.toggleImportModal}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleImportModal}
                                      >
                                        Import Participants from Excel
                                      </ModalHeader>
                                      <ModalBody>
                                        <div className="w-100 mb-3">
                                          <h6>
                                            <b>Fields that will be updated:</b>
                                          </h6>
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              color: "#555",
                                            }}
                                          >
                                            Name, Lab Type, Sector, City,
                                            District, Province, Notification
                                            Person Name, Designation, Contact
                                            No, Shipping Address, Billing
                                            Address {/* ← added */}
                                          </p>
                                          <h6 style={{ color: "red" }}>
                                            <b>
                                              Fields that will NEVER change:
                                            </b>
                                          </h6>
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              color: "#888",
                                            }}
                                          >
                                            Payment Status, Membership Status,
                                            Email, Password, Lab Code, Schemes{" "}
                                            {/* ← removed Billing Address */}
                                          </p>
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              color: "#f57c00",
                                            }}
                                          >
                                            ⚠️ Participants are matched by{" "}
                                            <b>Email</b> (database-unique per
                                            lab). The Excel file must have an{" "}
                                            <b>Email</b> column. Use{" "}
                                            <b>Export to Excel</b> to download
                                            the correct format — it already
                                            includes Email. Rows without a
                                            matching email will be skipped.
                                          </p>
                                        </div>

                                        {this.state.importError && (
                                          <div className="alert alert-danger">
                                            {this.state.importError}
                                          </div>
                                        )}

                                        <div>
                                          <Label className="fw-bold">
                                            Upload Excel File (.xlsx)
                                          </Label>
                                          <input
                                            type="file"
                                            className="form-control"
                                            accept=".xlsx,.xls"
                                            onChange={(e) =>
                                              this.setState({
                                                importFile: e.target.files[0],
                                              })
                                            }
                                          />
                                        </div>

                                        <Row className="mt-4">
                                          <Col
                                            sm="12"
                                            className="d-flex justify-content-end"
                                          >
                                            <Button
                                              color="primary"
                                              onClick={this.handleImport}
                                              className="me-2"
                                            >
                                              Upload
                                            </Button>
                                            <Button
                                              color="secondary"
                                              onClick={this.toggleImportModal}
                                            >
                                              Cancel
                                            </Button>
                                          </Col>
                                        </Row>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantListN.propTypes = {
  match: PropTypes.object,
  AllLabs: PropTypes.array,
  className: PropTypes.any,
  onGetPendingLabs: PropTypes.func,
  onApproveUnapproveLab: PropTypes.func,
  history: PropTypes.any,
  onupdateAllLabs: PropTypes.any,
  onAddNewPayment: PropTypes.func,
  onupdateMembershipStatus: PropTypes.func,
  ongetDeleteParticipant: PropTypes.func,
  participantId: PropTypes.func,
  onGetCityList: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  approvedLabs: PropTypes.array,
  onGetProvinceList: PropTypes.func,
  onGetParticipantPayment: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string, // Ensure 'search' is a string
  }).isRequired, // Make it required if always expected

  CycleList: PropTypes.array,
  PaymentSchemeList: PropTypes.array,
  isPaymentModalOpen: PropTypes.array,
  togglePaymentModal: PropTypes.array,
  isMembershipModalOpen: PropTypes.array,
  toggleMembershipModal: PropTypes.array,
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  onGetdesignationlist: PropTypes.func,
  ListDesignation: PropTypes.array,
  onGetDepartmentList: PropTypes.func,
  onGetCountryList: PropTypes.func,
  onGettypelist: PropTypes.func,
  onGetsectorlist: PropTypes.func,
  ListDepartment: PropTypes.array,
  ListCountry: PropTypes.array,
  ListType: PropTypes.array,
  ListSector: PropTypes.array,
};
const mapStateToProps = ({
  Account,
  registrationAdmin,
  ListCity,
  ListDistrict,
  ListProvince,
  CycleList,
  PaymentScheme,
  ListDesignation,
  ListDepartment,
  ListCountry,
  ListType,
  ListSector,
}) => {
  const cycleList = registrationAdmin.CycleList || [];
  const paymentSchemeList = PaymentScheme?.PaymentSchemeList || [];
  return {
    userID: Account.userID,
    AllLabs: registrationAdmin.AllLabs,
    approvedLabs: registrationAdmin.approvedLabs || [],
    CycleList: CycleList.CycleList, // Ensure it never returns undefined
    ListCity: ListCity?.ListCity || [],
    ListDistrict: ListDistrict?.ListDistrict || [],
    ListProvince: ListProvince.ListProvince,
    ListDesignation: ListDesignation.ListDesignation,
    ListDepartment: ListDepartment.ListDepartment,
    ListCountry: ListCountry.ListCountry,
    ListType: ListType.ListType,
    ListSector: ListSector.ListSector,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onApproveUnapproveLab: (data) => dispatch(approveUnapproveLab(data)),
  onGetPendingLabs: (id) => dispatch(getAllLabs(id)),
  onGetInstrumentTypeList: (id) => dispatch(getSchemelist(id)),
  onAddNewType: (id, createUnit) => dispatch(addNewSchemeList(id, createUnit)),
  onUpdateType: (id, methodlist) =>
    dispatch(updateSchemeList({ id, ...methodlist })),
  onupdateAllLabs: (updatedData) => {
    dispatch(updateAllLabs(updatedData));
  },
  onGetParticipantPayment: (id) => dispatch(getParticipantSchemelist(id)),
  ongetApprovedLabs: (id) => dispatch(getApprovedLabs(id)),
  // onGetCityList: id => dispatch(getcitylist(id)),
  // onGetDistrictList: id => dispatch(getdistrictlist(id)),
  // onGetdesignationlist: id => dispatch(getdesignationlist(id)),
  // onGetProvinceList: id => dispatch(getprovincelist(id)),
  ongetDeleteParticipant: (id, resolve, reject) =>
    dispatch(getDeleteParticipant(id, resolve, reject)),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
  // onAddNewPayment: (id, payment) => dispatch(addNewPayment(id, payment)),
  onupdateMembershipStatus: (id, status) => {
    dispatch(updateMembershipStatus({ id, ...status }));
  },
  // onGetDepartmentList: id => dispatch(getdepartmentlist(id)),
  // onGetCountryList: id => dispatch(getcountrylist(id)),
  // onGettypelist: id => dispatch(gettypelist(id)),
  // onGetsectorlist: id => dispatch(getsectorlist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ParticipantListN));
